import { createElement, styled, composedProps } from '@vebox/etui-system';

const ImgElement = createElement('img');
const Img = styled(ImgElement)(composedProps);
Img.displayName = 'Img';

export { Img };
